import { put, call, delay } from 'redux-saga/effects';

import { addressPickerAction } from '@epi-store/addressPicker/addressPicker.slice';
import storage from '@epi-helpers/StorageHelper';

import { logout } from '../../repositories/LogoutRepository';
import {
  ApplicationConstants,
  ApiConstants,
  ProfileConstants
} from '../../constants/actions';
import * as apiActions from '../../actions/api';
import * as overlaysActions from '../../actions/overlays';
import { goToPage } from '../../actions/navigation';
import emptyApi from '@epi-api/emptyApi';
import { onboardingActions } from '@epi-store/onboarding/onboarding.slice';

export default function* ApiLogout({ sessionExpired, gotoUrl = '' }) {
  try {
    yield call(logout);
    yield put({
      type: `${ApplicationConstants.CLEAR_FORMS}`
    });
    yield put({
      type: `${ApiConstants.LOGOUT_ACTION}_SUCCESS`
    });
    if (gotoUrl) {
      yield delay(0);
      yield put(goToPage(gotoUrl));
    }
    const message = sessionExpired
      ? { message: 'messages.session_expired' }
      : { message: 'messages.successful_logout' };
    const messageLevel = sessionExpired ? 'error' : 'success';
    yield put(overlaysActions.showNotification(message, messageLevel));
    yield put(apiActions.dismissApiErrors());
    yield put(addressPickerAction.restoreInitialValues());
    yield put({
      type: `${ProfileConstants.CLEAR_PROFILE}`
    });
  } catch (error) {
    yield put({
      type: `${ApiConstants.LOGOUT_ACTION}_FAILURE`,
      payload: error,
      isError: true
    });
    yield put(
      overlaysActions.showNotification(
        { message: 'messages.logout_failed' },
        'error'
      )
    );
  } finally {
    yield put(emptyApi.util.resetApiState());
    yield put(onboardingActions.resetState());
    storage.clear('rememberMe');
  }
}
